var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('div',[_c('v-text-field',{attrs:{"label":_vm.value.label},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }